import {useEffect, useState} from "react";
import {BrowserRouter as Router, Route, Routes,} from "react-router-dom";

import {getAllArticlesService} from "./services/blog.services";
import {getExperimentEvaluationService} from "./services/experiments.services";
import ApplicationRouter from "./routers/ApplicationRouter";
import MainRouter from "./routers/MainRouter";

function App() {
    const [blogs, setBlogs] = useState([]);
    const [publicIP, setPublicIP] = useState(null);
    const [curpFillType, setCurpFillType] = useState(null);
    const [isHomePage, setIsHomePage] = useState(false);

    const getBlogEntries = async () => {
        try {
            const {success, data} = await getAllArticlesService(1, 3);
            if (success) {
                setBlogs(data.articles);
            }
        } catch (error) {
            console.log("getBlogEntries -> error: ", error);
        }
    };

    useEffect(() => {
        fetch("https://api.ipify.org?format=json")
            .then((response) => response.json())
            .then(async (data) => {
                const fillType = await getExperimentEvaluationService(
                    "web_curp_fill",
                    data.ip,
                    "autocompleted"
                );
                setCurpFillType(fillType);
                setPublicIP(data.ip);
            })
            .catch((error) => console.error(error))
            .finally(() => getBlogEntries());
    }, []);

    return (
        <Router>
            <Routes>
                <Route path="/app/*" element={<ApplicationRouter/>}/>
                <Route
                    path="/*"
                    element={
                        <MainRouter
                            blogs={blogs}
                            publicIP={publicIP}
                            curpFillType={curpFillType}
                            setIsHomePage={setIsHomePage}
                        />
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
